import type { i18n as i18nO, TFunction } from 'i18next';

export enum ELanguage {
    cs = 'cs',
    en = 'en',
    de = 'de',
}

export type T = TFunction<'translation', undefined, 'translation'>;
export * from 'i18next';
export * from './formErrors';
